import PropTypes from "prop-types";
import * as React from "react";
import { useContext } from "react";
import useEventCallback from "@restart/hooks/useEventCallback";
import LayoutModalContext from "./LayoutModalContext";
import Button from "../../../../lib/components/Button";

const propTypes = {
  /**
   * Provides an accessible label for the save
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  saveLabel: PropTypes.string,

  /**
   * Sets the variant for close button.
   */
  saveVariant: PropTypes.string,

  /**
   * Specify whether the Component should contain a close button
   */
  saveButton: PropTypes.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a ModalContext, the onHide will automatically be propagated up
   * to the parent `onHide`.
   */
  onSave: PropTypes.func,
};

const LayoutModalFooter = React.forwardRef(
  (
    {
      saveLabel = "Save",
      saveVariant,
      saveButton = false,
      onHide,
      children,
      ...props
    },
    ref
  ) => {
    const context = useContext(LayoutModalContext);

    const handleClick = useEventCallback(() => {
      context?.onHide();
      onHide?.();
    });

    return (
      <div ref={ref} {...props}>
        {children}
        {saveButton && <Button variant={saveVariant} onClick={handleClick} />}
      </div>
    );
  }
);

LayoutModalFooter.propTypes = propTypes;

export default LayoutModalFooter;
